import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import NotFoundPage from "../components/NotFoundPage";
import LoginPage from "../components/LoginPage";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Settings from "../components/Settings";
import Page from "../components/Page";
import PublicStatus from "../components/PublicStatus";
import Symlink from "../components/Symlink";
import CustomSymlink from "../components/CustomSymlink";
import Impersonate from "../components/Impersonate";
import VerifyEmail from "../components/VerifyEmail";
import SignupPage from "../components/SignupPage";
import Finance from "../components/Finance";
import PayVerif from "../components/PayVerif";
import ForgetPass from "../components/ForgetPass";
import ResetPass from "../components/ResetPass";
import ToS from "../components/ToS";

export const history = createBrowserHistory();

const AppRouter = (props) => {
  return (
    <>
      <Router history={history}>
        <Switch>
          <PublicRoute path="/login" component={LoginPage} exact={true} />
          <Route path="/tos" component={ToS} exact={true} />
          <PublicRoute path="/signup" component={SignupPage} exact={true} />
          <PublicRoute
            path="/reset_password"
            component={ResetPass}
            exact={true}
          />
          <PublicRoute
            path="/forget_pass"
            component={ForgetPass}
            exact={true}
          />
          <PrivateRoute path="/settings" component={Settings} exact={true} />
          <PrivateRoute path="/finance" component={Finance} exact={true} />
          <PrivateRoute path="/monitor/:id" component={Page} />
          <PrivateRoute path="/public_status/:id" component={PublicStatus} />
          <PrivateRoute path="/" component={Page} exact={true} />
          <Route path="/impersonate" component={Impersonate} exact={true} />
          <Route path="/symlink/:token" component={Symlink} exact={true} />
          <Route
            path="/custom_symlink/:org/:token"
            component={CustomSymlink}
            exact={true}
          />
          <Route path="/verify_email" component={VerifyEmail} exact={true} />
          <Route
            path="/zarinpal_transaction_result"
            component={PayVerif}
            exact={true}
          />
          <Route path="/buy_plan_res" component={PayVerif} exact={true} />
          <PublicRoute
            path="/guest"
            component={LoginPage}
            asGuest
            exact={true}
          />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </>
  );
};

export default AppRouter;
